import { FabricObject } from 'fabric';

import {
  DRAW_OBJECT_TYPE_SQUARE,
  OBJECT_DATA_SHAPE_KEY,
} from '../draw-canvas.constants';
import { isRectangle } from './is-rectangle';

export const isSquare = (object: FabricObject) => {
  return (
    isRectangle(object) &&
    OBJECT_DATA_SHAPE_KEY in object &&
    object[OBJECT_DATA_SHAPE_KEY] === DRAW_OBJECT_TYPE_SQUARE
  );
};
